import { render, staticRenderFns } from "./ClientEditPanel.vue?vue&type=template&id=06eaace9&"
import script from "./ClientEditPanel.vue?vue&type=script&lang=js&"
export * from "./ClientEditPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports